export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14469.d1ed4cca.jpg";